/**
 * FLOGOM — Filtres couleur avec swatches visuels
 */
(function () {
  'use strict';

  const COLOR_MAP = {
    'blanc':       { bg: '#ffffff',    border: '#d0d0d0' },
    'noir':        { bg: '#111111',    border: '#111111' },
    'gris':        { bg: '#9e9e9e',    border: '#9e9e9e' },
    'vert':        { bg: '#2d7a4f',    border: '#2d7a4f' },
    'bleu':        { bg: '#1565c0',    border: '#1565c0' },
    'bleu marine': { bg: '#0d2161',    border: '#0d2161' },
    'rouge':       { bg: '#c0392b',    border: '#c0392b' },
    'rose':        { bg: '#e91e8c',    border: '#e91e8c' },
    'marron':      { bg: '#6b3f2a',    border: '#6b3f2a' },
    'beige':       { bg: '#d4b896',    border: '#c4a886' },
    'jaune':       { bg: '#f5c518',    border: '#c8a200' },
    'violet':      { bg: '#7b3fa0',    border: '#7b3fa0' },
    'orange':      { bg: '#e87020',    border: '#e87020' },
    'argent':      { bg: '#b8c4ce',    border: '#a0acb6' },
    'bordeaux':    { bg: '#6b1a2a',    border: '#6b1a2a' },
    'dore':        { bg: '#d4af37',    border: '#b89620' },
    'multicolore': { bg: 'linear-gradient(135deg,#e53e3e,#e87020,#f5c518,#2d7a4f,#1565c0,#7b3fa0)', border: '#aaa' },
  };

  function capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function extractColorKey(text) {
    text = text.toLowerCase().trim();
    // Handle accented characters for dore/doré
    text = text.replace('é', 'e').replace('è', 'e');
    const match = text.match(/^couleur:(.+)$/);
    if (match) return match[1].trim();
    if (COLOR_MAP[text]) return text;
    return null;
  }

  function getDisplayName(colorKey) {
    const names = {
      'blanc': 'Blanc', 'noir': 'Noir', 'gris': 'Gris',
      'vert': 'Vert', 'bleu': 'Bleu', 'bleu marine': 'Bleu marine',
      'rouge': 'Rouge', 'rose': 'Rose', 'marron': 'Marron',
      'beige': 'Beige', 'jaune': 'Jaune', 'violet': 'Violet',
      'orange': 'Orange', 'argent': 'Argent', 'bordeaux': 'Bordeaux',
      'dore': 'Doré', 'multicolore': 'Multicolore',
    };
    return names[colorKey] || capitalize(colorKey);
  }

  function createSwatch(colorKey) {
    const c = COLOR_MAP[colorKey];
    if (!c) return null;
    const el = document.createElement('span');
    el.className = 'flogom-color-swatch';
    el.setAttribute('aria-hidden', 'true');
    const bgProp = c.bg.includes('gradient') ? 'background' : 'background-color';
    el.style.cssText = [
      'display:inline-block',
      'width:18px',
      'height:18px',
      'border-radius:4px',
      'flex-shrink:0',
      'vertical-align:middle',
      'border:1.5px solid ' + c.border,
      bgProp + ':' + c.bg,
      'box-shadow:inset 0 0 0 1px rgba(0,0,0,0.06)',
    ].join(';');
    return el;
  }

  function processLabel(label) {
    if (label.dataset.flogomDone) return;
    const fullText = label.textContent || '';
    if (!fullText.toLowerCase().includes('couleur:')) return;

    const childNodes = Array.from(label.childNodes);
    for (var i = 0; i < childNodes.length; i++) {
      var node = childNodes[i];

      if (node.nodeType === Node.TEXT_NODE) {
        var raw = node.textContent.trim();
        var colorKey = extractColorKey(raw);
        if (!colorKey) continue;
        var swatch = createSwatch(colorKey);
        if (!swatch) continue;
        var nameSpan = document.createElement('span');
        nameSpan.textContent = getDisplayName(colorKey);
        var wrapper = document.createElement('span');
        wrapper.className = 'flogom-color-label';
        wrapper.style.cssText = 'display:inline-flex;align-items:center;gap:7px;';
        wrapper.appendChild(swatch);
        wrapper.appendChild(nameSpan);
        label.replaceChild(wrapper, node);
        label.dataset.flogomDone = '1';
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        var tag = node.tagName.toUpperCase();
        if (tag === 'INPUT' || tag === 'SVG' || tag === 'BUTTON') continue;
        if (node.classList && node.classList.contains('facets__count')) continue;
        var inner = node.textContent.trim();
        var colorKey2 = extractColorKey(inner);
        if (!colorKey2) continue;
        var swatch2 = createSwatch(colorKey2);
        if (!swatch2) continue;
        var clone = node.cloneNode(false);
        clone.textContent = getDisplayName(colorKey2);
        var wrapper2 = document.createElement('span');
        wrapper2.className = 'flogom-color-label';
        wrapper2.style.cssText = 'display:inline-flex;align-items:center;gap:7px;';
        wrapper2.appendChild(swatch2);
        wrapper2.appendChild(clone);
        node.parentNode.replaceChild(wrapper2, node);
        label.dataset.flogomDone = '1';
        return;
      }
    }
    label.dataset.flogomDone = '1';
  }

  function processFacets(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    var labels = root.querySelectorAll('.facets__list label, .facets__list .facet-checkbox');
    labels.forEach(function (label) {
      if ((label.textContent || '').toLowerCase().includes('couleur:')) {
        processLabel(label);
      }
    });
  }

  function init() {
    processFacets();
    var observer = new MutationObserver(function (mutations) {
      var needsUpdate = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) { needsUpdate = true; break; }
      }
      if (needsUpdate) setTimeout(processFacets, 80);
    });
    var filterRoot =
      document.querySelector('#main-collection-filters') ||
      document.querySelector('.facets-container') ||
      document.body;
    observer.observe(filterRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(processFacets, 150);
  });

})();
